import React from "react";

function UseCasesLottery() {
  const cases = [
    {
      title: "NFT Lottery",
      desc: "Introduce scarcity and additional value through NFT-based drawings, creating high-engagement opportunities for digital asset enthusiasts and collectors.",
    },
    {
      title: "Yield-Generating Lotteries",
      desc: "Provide ticket buyers with the chance to win prizes generated exclusively from interest earned on network-wide liquidity pools and funds.",
    },
    {
      title: "Community-Based Lotteries",
      desc: "Empower communities to create and manage their own drawings and reward systems, promoting localized autonomous participation based on absolute transparency.",
    },
  ];

  return (
    <div className="about-area pt-5 pb-5 default-padding">
      <div className="container">
        <div className="row text-center mb-5">
          <div className="col-lg-8 offset-lg-2">
            <h2 className="title fw-bold">Popular Use Cases of DeFi Lottery</h2>
            <p className="mt-3">
              Explore how our robust DeFi lottery platforms can help you launch
              customized and randomized lottery systems.
            </p>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="">
              {cases.map((useCase, index) => (
                <div className="mb-4" key={index}>
                  <h4 className="fw-bold fs-5 mb-2">{useCase.title}</h4>
                  <p
                    style={{
                      fontSize: "15px",
                      color: "#555",
                      lineHeight: "1.7",
                    }}
                  >
                    {useCase.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className="col-lg-6 text-center">
            <div className="thumb position-relative">
              <img
                src="/assets/img/illustration/3.png" // placeholder for NFT/Lottery image
                alt="Use Cases of DeFi Lottery"
                style={{
                  maxWidth: "100%",
                  borderRadius: "10px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
                }}
              />
              <div
                className="position-absolute top-50 start-50 translate-middle text-white fw-bold display-4"
                style={{
                  opacity: "0.2",
                  letterSpacing: "10px",
                  pointerEvents: "none",
                }}
              >
                NFT
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UseCasesLottery;
